import { render, staticRenderFns } from "./FaceScan.vue?vue&type=template&id=40e05dda&scoped=true&"
import script from "./Camera.js?vue&type=script&lang=js&"
export * from "./Camera.js?vue&type=script&lang=js&"
import style0 from "./FaceScan.vue?vue&type=style&index=0&id=40e05dda&prod&lang=scss&"
import style1 from "./FaceScan.vue?vue&type=style&index=1&id=40e05dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e05dda",
  null
  
)

export default component.exports